import QuestionCircleIcon from "@/assets/colorable/question_circle.svg?react";
import {type FC, memo} from "react";
import {useIntercom} from "react-use-intercom";

const NavbarIntercomToggle: FC = () => {
  const {show, hide, isOpen} = useIntercom();

  return (
    <QuestionCircleIcon
      onClick={() => {
        if (isOpen) {
          hide();
        } else {
          show();
        }
      }}
      className="text-primary-dark-solid size-5 cursor-pointer transition-all duration-150 hover:scale-[1.1] hover:opacity-75"
    />
  );
};

export default memo(NavbarIntercomToggle);
